export default __webpack_public_path__ + "static/coperta-penny-fm-ed84b37dd72601c931a390d3f1c46bd5.jpg";